import { BaseScene } from '@core/scenes/BaseScene';
import { SceneKeys } from '@core/config/constants';

/**
 * Primera escena. Sirve para inicializar configuracion ligera (escala, input) antes
 * de cargar assets pesados en la PreloadScene.
 */
export class BootScene extends BaseScene {
  public constructor() {
    super(SceneKeys.Boot);
  }

  public create(): void {
    this.scene.start(SceneKeys.Preload);
  }
}
